var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.noHeaderFooter)?_c('div',{attrs:{"id":"aiapp"}},[_c('keep-alive',[_c('router-view')],1)],1):_c('div',{attrs:{"id":"app"}},[_c('xgHeader'),_vm._v(" "),_c('keep-alive',[_c('div',{style:({ minHeight: _vm.Height + 'px' }),attrs:{"id":"v-content"}},[_c('router-view')],1)]),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7caeef51","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 